export * from './components/Shimmer/index';
//# sourceMappingURL=Shimmer.js.map